import React from "react";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import camelCase from "lodash/camelCase";
import { getValueFromInput } from "util/FormsUtils";
import { Input, Button, ControlLabel, FormControl, FormGroup, HelpBlock, InputGroup } from "components/bootstrap";
import { ColorPickerPopover, TimezoneSelect } from "components/common";
import ColorLabel from "components/sidecars/common/ColorLabel";
import DocsHelper from "util/DocsHelper";
import DocumentationLink from "components/support/DocumentationLink";
class TeamsNotificationForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleBacklogSizeChange = (event) => {
      const { name } = event.target;
      const value = getValueFromInput(event.target);
      this.setState({ [camelCase(name)]: value });
      this.propagateChange(name, getValueFromInput(event.target));
    };
    this.toggleBacklogSize = () => {
      const { isBacklogSizeEnabled, backlogSize } = this.state;
      this.setState({ isBacklogSizeEnabled: !isBacklogSizeEnabled });
      this.propagateChange("backlog_size", isBacklogSizeEnabled ? 0 : backlogSize);
    };
    this.propagateChange = (key, value) => {
      const { config, onChange } = this.props;
      const nextConfig = cloneDeep(config);
      nextConfig[key] = value;
      onChange(nextConfig);
    };
    this.handleColorChange = (color, _, hidePopover) => {
      hidePopover();
      this.propagateChange("color", color);
    };
    this.handleTimeZoneChange = (nextValue) => {
      this.propagateChange("time_zone", nextValue);
    };
    this.handleChange = (event) => {
      const { name } = event.target;
      this.propagateChange(name, getValueFromInput(event.target));
    };
    const defaultBacklogSize = props.config.backlog_size;
    this.state = {
      isBacklogSizeEnabled: defaultBacklogSize > 0,
      backlogSize: defaultBacklogSize
    };
  }
  render() {
    const { config, validation } = this.props;
    const { isBacklogSizeEnabled, backlogSize } = this.state;
    const element = /* @__PURE__ */ React.createElement("p", null, "Custom message to be appended below the alert title. See", " ", /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.ALERTS, text: "docs " }), " for more details.");
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "color" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Configuration color"), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ColorLabel, { color: config.color }), /* @__PURE__ */ React.createElement("div", { style: { display: "inline-block", marginLeft: 15 } }, /* @__PURE__ */ React.createElement(
      ColorPickerPopover,
      {
        id: "color",
        color: config.color || "#f06292",
        placement: "right",
        triggerNode: /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall" }, "Change color"),
        onChange: this.handleColorChange
      }
    ))), /* @__PURE__ */ React.createElement(HelpBlock, null, "Choose a color to use for this configuration.")), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "notification-webhookUrl",
        name: "webhook_url",
        label: "Webhook URL",
        type: "text",
        bsStyle: validation.errors.webhook_url ? "error" : null,
        help: get(validation, "errors.webhook_url[0]", 'Teams "Incoming Webhook" URL'),
        value: config.webhook_url || "",
        onChange: this.handleChange,
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "notification-customMessage",
        name: "custom_message",
        label: "Custom Message (optional)",
        type: "textarea",
        bsStyle: validation.errors.custom_message ? "error" : null,
        help: get(validation, "errors.custom_message[0]", element),
        value: config.custom_message || "",
        onChange: this.handleChange
      }
    ), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "notification-time-zone",
        help: "Time zone used for timestamps in the notification body.",
        label: "Time zone for date/time values"
      },
      /* @__PURE__ */ React.createElement(
        TimezoneSelect,
        {
          className: "timezone-select",
          name: "time_zone",
          value: config.time_zone,
          onChange: this.handleTimeZoneChange,
          clearable: false
        }
      )
    ), /* @__PURE__ */ React.createElement(ControlLabel, null, "Message Backlog Limit (optional)"), /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(InputGroup.Addon, null, /* @__PURE__ */ React.createElement(
      "input",
      {
        id: "toggle_backlog_size",
        type: "checkbox",
        checked: isBacklogSizeEnabled,
        onChange: this.toggleBacklogSize
      }
    )), /* @__PURE__ */ React.createElement(
      FormControl,
      {
        type: "number",
        id: "backlog_size",
        name: "backlog_size",
        onChange: this.handleBacklogSizeChange,
        value: backlogSize,
        min: "0",
        disabled: !isBacklogSizeEnabled
      }
    )), /* @__PURE__ */ React.createElement(HelpBlock, null, "Limit the number of backlog messages sent as part of the Microsoft Teams notification. If set to 0, no limit will be enforced.")), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "notification-iconUrl",
        name: "icon_url",
        label: "Icon URL (optional)",
        type: "text",
        bsStyle: validation.errors.icon_url ? "error" : null,
        help: get(validation, "errors.icon_url[0]", "Image to use as the icon for this message"),
        value: config.icon_url || "",
        onChange: this.handleChange
      }
    ));
  }
}
TeamsNotificationForm.defaultConfig = {
  color: "#FF0000",
  webhook_url: "",
  /* eslint-disable no-template-curly-in-string */
  custom_message: "<b>--- [Event Definition] ---</b>\n<table>\n<tr><td><b>Title:</b></td><td>${event_definition_title}</td></tr>\n<tr><td><b>Type:</b></td><td>${event_definition_type}</td></tr>\n<table>\n\n<b>--- [Event] ---</b>\n<table>\n<tr><td><b>Alert Replay:</b></td><td>${http_external_uri}alerts/${event.id}/replay-search</td></tr>\n<tr><td><b>Timestamp:</b></td><td>${event.timestamp}</td></tr>\n<tr><td><b>Message:</b></td><td>${event.message}</td></tr>\n<tr><td><b>Source:</b></td><td>${event.source}</td></tr>\n<tr><td><b>Key:</b></td><td>${event.key}</td></tr>\n<tr><td><b>Priority:</b></td><td>${event.priority}</td></tr>\n<tr><td><b>Alert:</b></td><td>${event.alert}</td></tr>\n<tr><td><b>Timestamp Processing:</b></td><td>${event.timestamp}</td></tr>\n<tr><td><b>Timerange Start:</b></td><td>${event.timerange_start}</td></tr>\n<tr><td><b>Timerange End:</b></td><td>${event.timerange_end}</td></tr>\n<table>\n\n<b>Event Fields:</b>\n<table>\n${foreach event.fields field}\n<tr><td><b>${field.key}:</b></td><td>${field.value}</td></tr>\n${end}\n</table>\n\n${if backlog}\n<b>--- [Backlog] ---</b>\n${foreach backlog message}\n<p><code>${message.timestamp}  ::  ${message.source}  ::  ${message.message}</code></p>\n${end}${end}",
  /* eslint-enable no-template-curly-in-string */
  icon_url: "",
  backlog_size: 0,
  time_zone: "UTC"
};
export default TeamsNotificationForm;
